import "./Pipeline.css";
import worksmithBg from "../../assets/backgrounds/worksmith.jpeg";
import aideraBg from "../../assets/backgrounds/aidera-bg.jpeg";
import worksmithLogo from "../../assets/logos/worksmith-logo.png";
import aideraLogo from "../../assets/logos/aidera-logo.png";
import omniaBg from "../../assets/backgrounds/omnia.jpeg";
import omniaLogo from "../../assets/logos/omnia.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const ventures = [
  {
    category: "Real Estate",
    name: "Worksmith",
    tagline: "Redefining Work and Collaboration",
    description:
      "Worksmith is our actively operating creative ecosystem platform, designed to transform how professionals work, connect, and grow. Blending workspace, community, and lifestyle, Worksmith delivers purpose-built environments that foster productivity, collaboration, and innovation. With its first locations successfully launched, the platform is positioned for scalable expansion across key urban markets.",
    src: worksmithBg,
    logo: worksmithLogo,
    link: "https://myworksmith.com/",
  },
  {
    category: "Technology",
    name: "Aidera",
    tagline: "Engineering the Future of Intelligent Systems",
    description:
      "Aidera represents our strategic investment in next-generation artificial intelligence infrastructure and intelligent operating systems. Currently in its pre-market stage, Aidera is focused on building an enterprise-grade AI SaaS Platform that enhances decision-making, automates operations, and redefines how businesses interact with data, customers, and environments.",
    src: aideraBg,
    logo: aideraLogo,
    link: "https://aidera.io/",
  },
  {
    category: "Healthcare & Biotech",
    name: "Omnia Health Sciences",
    tagline: "Beyond Wellness. Within Biology.",
    description:
      "Omnia Health Sciences is our science-led biotechnology and translational science venture focused on developing precision-driven human performance and health formulations grounded in advanced molecular research. Built upon the work of globally recognized scientists, Omnia bridges the gap between laboratory science and real-world human application through evidence-led systems, scientific validation, and advanced formulation architecture. Positioned at the intersection of biotechnology, nutritional science, and human optimization, Omnia is establishing a new scientific standard for next-generation health solutions.",
    src: omniaBg,
    logo: omniaLogo,
    link: "https://omniahealthsciences.com/",
  },
];

function Pipeline() {
  return (
    <div id="pipeline">
      <div className="pipeline-container">
        <div className="pipeline-header">
          <h1>Other Investments</h1>
          <p className="pipeline-subtitle">
            Active Portfolio &amp; Innovation Pipeline
          </p>
          <p className="pipeline-intro">
            We invest in and build high-potential ventures across sectors where
            innovation, technology, and human experience intersect — combining
            execution today with long-term transformative growth.
          </p>
        </div>

        <div className="pipeline-ventures">
          {ventures.map((venture, index) => (
            <div className="pipeline-venture" key={index}>
              <div className="pipeline-venture-image">
                {venture.src.includes('.mp4') ? (
                  <video src={venture.src} autoPlay muted loop style={{ opacity: 0.9 }} />
                ) : (
                  <img src={venture.src} alt={venture.name} />
                )}
                <div className="pipeline-venture-overlay"></div>
                <span className="pipeline-venture-category">
                  {venture.category}
                </span>
              </div>
              <div className="pipeline-venture-content">
                <img
                  src={venture.logo}
                  alt={`${venture.name} logo`}
                  className="pipeline-venture-logo"
                  style={{ width: venture.name.toLowerCase().includes("aidera") ? "100px" : "140px" }}
                />
                <h3>{venture.tagline}</h3>
                <p>{venture.description}</p>
                {venture.link && (
                  <a
                    href={venture.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pipeline-venture-link"
                  >
                    Learn More{" "}
                    <FontAwesomeIcon icon={faArrowRight} />
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Pipeline;
